import Events from "components/events";
import StandFields from "components/stands/fields";
import { Localize } from "components/service";
import StandsGlobalFields from "../fields";


const emptyValue = <strong>&mdash;</strong>;
const whiteText = (value) => <strong style={ { color: 'white' } }>{ value }</strong>;

const standsGlobalColumns = [
    {
        title: <Localize>TABLES.Column_Title_ExhibitionName</Localize>,
        dataIndex: 'exhibition_name',
        columnIndex: 'EE_ID',
        sorter: true,
        width: '14%',
    },
    {
        title: <Localize>TABLES.Column_Title_Exhibitor</Localize>,
        dataIndex: 'exhibitor',
        columnIndex: 'EXHIBITOR',
        sorter: true,
        width: '14%',
    },
    {
        title: <Localize>TABLES.Column_Title_AcquiseNumber</Localize>,
        dataIndex: 'aquise_number',
        columnIndex: 'AQUISE_NUMBER',
        sorter: true,
    },
    {
        title: <Localize>TABLES.Column_Title_ProaufNumber</Localize>,
        dataIndex: 'proauf_number',
        columnIndex: 'PROAUF_NUMBER',
        sorter: true,
    },
    {
        title: <Localize>TABLES.Column_Title_Hall</Localize>,
        dataIndex: 'hall_name',
        columnIndex: 'HALL_NAME',
        sorter: true,
    },
    {
        title: <Localize>TABLES.Column_Title_Corridor</Localize>,
        dataIndex: 'corridor',
        columnIndex: 'CORRIDOR',
        sorter: true,
    },
    {
        title: <Localize>TABLES.Column_Title_Block</Localize>,
        dataIndex: 'block',
        columnIndex: 'BLOCK',
        sorter: true,
    },
    {
        title: <Localize>TABLES.Column_Title_StandNumber</Localize>,
        dataIndex: 'stand_number',
        columnIndex: 'STAND_NUMBER',
        sorter: true,
    },
    {
        title: <Localize>TABLES.Column_Title_CadNumber</Localize>,
        dataIndex: 'cad_number',
        columnIndex: 'CAD_NUMBER',
        sorter: true,
    },
    {
        title: <Localize>TABLES.Column_Title_Comments</Localize>,
        dataIndex: 'comments',
        columnIndex: 'COMMENTS_COUNT',
        align: 'center',
    },
    {
        title: <Localize>TABLES.Column_Title_DamageFilesCount</Localize>,
        dataIndex: 'damageFilesCount',
        columnIndex: 'DAMAGES_FILES_COUNT',
        align: 'center',
    },
    {
        title: <Localize>TABLES.Column_Title_Materials</Localize>,
        dataIndex: 'materials',
        columnIndex: 'MATERIALS',
        width: '10.6%',
    },
];


const standsGlobalData = (stands) => {

    if (!stands)
    {
        return [];
    }

    return stands.map(stand => {
        const eventID = stand.exhibitionEvent?.id ?? stand.ee_id;
        const eventTitle = stand.exhibitionEvent?.title;
        const hallID = stand.hall?.id ?? stand.hall_id;
        const hallTitle = stand.hall_name ?? stand.hall?.title;

        return {
            key: stand.id,
            exhibition_name: eventID && eventTitle ?
                <Events.Fields.Link id={ eventID } title={ eventTitle } />
                :
                emptyValue,
            exhibitor: eventID && stand.exhibitor ?
                <StandFields.Title eeID={ eventID } id={ stand.id } title={ stand.exhibitor } />
                :
                stand.exhibitor ? whiteText(stand.exhibitor) : emptyValue,
            aquise_number: stand.aquise_number ?? emptyValue,
            proauf_number: stand.proauf_number ?? emptyValue,
            hall_name: eventID && hallID && hallTitle ?
                <StandFields.Link eeID={ eventID } id={ hallID } title={ hallTitle } />
                :
                emptyValue,
            corridor: stand.corridor?.length > 0 ? stand.corridor : emptyValue,
            block: stand.block?.length > 0 ? stand.block : emptyValue,
            stand_number: stand.stand_number?.length > 0 ? stand.stand_number : emptyValue,
            cad_number: stand.cad_number?.length > 0 ? stand.cad_number : emptyValue,
            comments: <StandFields.Comments stand={ stand } />,
            damageFilesCount: stand.damageFilesCount ?? emptyValue,
            materials: <StandsGlobalFields.Materials stand={ stand } />,
        };

    });
};


const StandsGlobalTableHelper = {
    columns: standsGlobalColumns,
    data: standsGlobalData,
}

export default StandsGlobalTableHelper;
